<script setup lang="ts">
const config = useRuntimeConfig();
const { site } = useSite();

const environmentName = computed(() => String(config.public.environmentName ?? "").trim());
const bannerColor = computed(() => String(config.public.nonProdBannerColor ?? "").trim() || "#f59e0b");

const isProduction = computed(() => {
  const name = environmentName.value.toLowerCase();
  return name === "production" || name === "prod";
});

const bannerDisabled = computed(() => {
  const value = site.value?.settings?.disable_non_production_banner;
  return value === true || value === "true";
});

const show = computed(() =>
  environmentName.value.length > 0
  && !isProduction.value
  && !bannerDisabled.value
);
</script>

<template>
  <div
    v-if="show"
    class="flex items-center justify-center gap-2 px-4 py-2 text-[13px] font-medium text-white"
    :style="{ backgroundColor: bannerColor }"
  >
    <span class="shrink-0 rounded bg-black/20 px-2 py-0.5 font-semibold uppercase tracking-wide">
      {{ environmentName }}
    </span>
    <span class="min-w-0 truncate">
      You are using the <strong>{{ environmentName }}</strong> environment. This is not production — data may be changed or reset at any time.
    </span>
  </div>
</template>
